import { render, staticRenderFns } from "./L03Animation.vue?vue&type=template&id=23b8bf2f&"
import script from "./L03Animation.vue?vue&type=script&lang=js&"
export * from "./L03Animation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports